// Import CSS
import './index.css'

// Import JS
import Lenis from 'lenis';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import initHeadingAnimations from './heading-animations';

gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

const lenis = new Lenis({
    autoRaf: true,
    duration: 1,
    anchors: true,
    prevent: (node) => node.classList?.contains('localization-form__content') || node.classList?.contains('oke-modal') || node.classList?.contains('nm-modal-container')
});

ScrollTrigger.scrollerProxy(document.documentElement, {
    scrollTop(value) {
        if (arguments.length) {
            lenis.scrollTo(value, { immediate: true });
        }
        return lenis.scroll;
    },
    getBoundingClientRect() {
        return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
        };
    },
});

lenis.on('scroll', ScrollTrigger.update);
ScrollTrigger.addEventListener('refresh', () => lenis.resize());

// Expose for programmatic scroll (e.g. charm bar step navigation)
window.lenis = lenis;

initHeadingAnimations();
